"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalHeaderStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var _colors_1 = require("../../../../style/commons/_colors");
exports.useModalHeaderStyles = (0, styles_1.makeStyles)(function () { return ({
    main: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    icon: {
        cursor: 'pointer',
        fontSize: 24,
        color: _colors_1.brandPrimaryMaxDark,
        padding: 4,
        '&:hover': {
            backgroundColor: _colors_1.lightBlue,
        },
    },
    content: {},
}); });
